import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div class="poem">
      
      <p class="poem-block mb-5 text-center">* * *</p>

      
      <p class="poem-block mb-5">
        Выпил я стаканчик яду,<br/>
        Не один – седьмой уж кряду!<br/>
        Но, хоть силы мои бренны<br/>
        И цепляюсь я за стены,<br/>
        Не нужны пока мне требы:<br/>
        Вот восьмой стаканчик мне бы!<br/>
        Вышел бы я в чисто поле…<br/>
        Похмелиться бы мне, что ли?
      </p> 
      
      
      <p class="poem-block mb-5 text-center">* * *</p>

      
      <p class="poem-block mb-5">
        Ну не нравится мне перкуссия!<br/>
        Сомневаюсь уже в своём вкусе я:<br/>
        Ведь видала такие закаты<br/>
        Тех ансамблей, что были богаты, <br/>
        Но дождались других времён: <br/>
        Счастлив, кто в своё время рождён<br/>
        Не ища прошлогоднего снега.<br/>
        Так сказала мне alter ego. 
      </p> 
      
      
      <p class="poem-block mb-5 text-center">* * *</p>

      
      <p class="poem-block mb-5">
        Раз трубный глас послышался поэту<br/>
        Подобный грознозвучному кларнету:<br/>
        И предвещало данное пророчество<br/>
        Поэту в дольнем мире одиночество. <br/>
        Однако в нём надежда расцвела, <br/>
        Что будет он вкушать перепела, <br/>
        Что все пророчества – сплошная выдумка<br/>
        И их постигнет в Интернете выемка. 
      </p> 
      
      
      <p class="poem-block mb-5 text-center">* * *</p>

      
      <p class="poem-block mb-5">
        Гордо встал могучий катет, <br/>
        А на деле – только дунь –<br/>
        Он назад с размаху катит<br/>
        От дыханья многих Дунь. <br/>
        Заиграли грозно горны:<br/>
        Видно, время истекло<br/>
        И взметнулся воздух горный, <br/>
        Ставший твёрдым, как стекло.
      </p> 
      
      
      <p class="poem-block mb-5 text-center">* * *</p>

      
      <p class="poem-block mb-5">
        Нам вещает Кама-сутра,<br/>
        Что вода полезна с у́тра!<br/>
        Вот, в бассейн воды налив<br/>
        Через цинковые трубы,<br/>
        В яблочко «белый налив»<br/>
        Плотоядно вперив зубы,<br/>
        Наслаждаюсь летним днём:<br/>
        Уж добрался я до дачи<br/>
        И в бассейене своём<br/>
        Плыть желаю по-собачьи!
      </p> 
      
      
      <p class="poem-block mb-5 text-center">* * *</p>

      
      <p class="poem-block mb-5">
        Прискакал ко мне тушканчик,<br/>
        Быстро слопал одуванчик:<br/>
        Нужен нам весной салат,<br/>
        Нынче зелень нарасхват!<br/>
        Лёгкий ветерок весенний<br/>
        Завивает клён кудрявый;<br/>
        Он не левый и не правый –<br/>
        Нет для ветерка течений!<br/>
        Чтобы нас от бед избавить,<br/>
        Должен дырки он буравить<br/>
        Во стволах берёз седых:<br/>
        Будем пить мы сок из них,<br/>
        Чтоб здоровье сохранить<br/>
        И всегда в веселье быть!
      </p> 
      
      
      <p class="poem-block mb-5 text-center">* * *</p>

      
      <p class="poem-block mb-2">
        Как улыбается нам эта львица!<br/>
        Каким презреньем взор её искрится! <br/>
        Недаром ведь был даден нам урок:<br/>
        Из норки тайной выскочил сурок<br/>
        И рассказал ей, что уже давно<br/>
        В засаде заготовлено бревно,<br/>
        Которое огромная горилла<br/>
        Весь день по джунглям с грохотом возила,<br/>
        Чтоб наконец ей перекрыть проход,<br/>
        Чтобы не выбралась она ни вплавь, ни вброд<br/>
        И в сети наши крепкие попала<br/>
        И нас пугать ночами перестала.<br/>
        Но был напрасен заговор людей:<br/>
        Им не удастся покорить зверей.<br/>
        Одним прыжком перескочив засаду,<br/>
        Она хвостом махнула зоосаду,<br/>
        Оставив лишь на память о себе<br/>
        В фотоловушке снимок: «Бе-бе-бе!»
      </p> 
      
      <p class="mb-5" style="font-size: 95%;">
        <i>(Реальная история львицы из нашего зоопарка)</i>
      </p>
      
      
      <p class="poem-block mb-2 text-center">РОПАЛИЧЕСКИЕ СТИХИ</p>
      <p class="poem-block mb-5 text-center" style="font-size: 85%;">
        Ропалический стих (от греч. ῥοπαλικός — подобный палице, расширяющейся к концу) — древняя игровая форма стиха, в котором слова постепенно увеличиваются в своем слоговом объеме; первое — односложное, второе — двусложное, третье — трехсложное, четвертое — четырехсложное. Таким образом, стих как бы расширяется в виде палицы. Р. с. встречается у античных авторов. 
      </p>
      
      
      <p class="poem-block mb-5">
        Я помню зарево горящего Пантикапея…<br/>
        Ты видел города, кипящие столпотвореньем буйно-безобразным?<br/>
        Нет меры волшебству бездонному преображенья,<br/>
        Нет силы преломить настойчивость воображенья,<br/>
        Что тянет наугад в невиданные зазеркалия,<br/>
        Где бьётся невпопад безудержная вакханалия.
      </p> 

      
      <p class="poem-block mb-5">
        <i>
          Нет, это не для нашего языка. 
          Силлабическими виршами мы уже давно переболели; они нам не свойственны. 
          Нам нужно силлабо-тоническое стихосложение, да ещё и с рифмами. 
          Остальное – не стихи.
        </i>
      </p>

    </div>
    `
  )
}

const itemName = {
  rus: 'Буриме, написанные в тёплой компании'
}

const item = {
  itemlink: getLink(itemName.rus),
  rus:{
    itemName: itemName.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}


export default item;